import React from 'react';

import LoginForm from '../../presentational/LoginForm';

class LoginView extends React.Component {
    render() {
        return (
            <div>
                 <LoginForm />
            </div>
        )
    }
}

export default LoginView

